import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../../constants/ActionNameConstants';
import { CHANGE_PASSWORD_API_URL } from '../../../../../../constants/ApiUrlConstants';
import { WEB_URL } from '../../../../../../constants/Config';
import { LOGIN_ROUTE } from '../../../../../../constants/RouteNameConstants';
import { postApiRequest } from '../../../../../../features/axiosClient';
import history from '../../../../../../features/history';
import { changePasswordFailure, changePasswordSuccess } from '../actions';

const changePasswordAPI = (action) => postApiRequest(CHANGE_PASSWORD_API_URL, action);

function forwardTo(location) {
  history.push(location);
}

function* handleChangePasswordAPI(action) {
  try {
    const response = yield call(changePasswordAPI, action.payload);
    if (response?.data?.success && response?.data?.resultMessage !== '') {
      toast.success(response?.data?.resultMessage);
    }
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    if (response?.data?.success) {
      sessionStorage.clear();
      Cookies.remove('emailProofreader');
      Cookies.remove('passwordProofreader');
      Cookies.remove('userDataProofreader');
      Cookies.remove('sessionExpireModalOpenProofreader');
      yield call(forwardTo, LOGIN_ROUTE);
    }
    yield put(changePasswordSuccess(response));
  } catch (error) {
    yield put(changePasswordFailure(error));
  }
}

export function* watchChangePassword() {
  yield takeLatest(types.CHANGE_PASSSWORD_REQUEST, handleChangePasswordAPI);
}
